import type { Lesson } from '../schema.js';

export const OPENING_LESSONS: Lesson[] = [
  {
    id: 'opening-principles',
    slug: 'opening-principles',
    title: 'Opening principles',
    audienceLevel: 'beginner',
    concepts: ['opening', 'development'],
    steps: [
      {
        kind: 'explain',
        title: 'A good opening plan',
        body: 'The first moves of the game set you up for success. Follow three rules: fight for the center, develop your knights and bishops, and keep your king safe by castling.',
        narration: 'Use your opening moves to prepare your pieces.',
      },
      {
        kind: 'explain',
        title: 'Bring out a knight',
        body: 'Knights are the first pieces to move. A knight on f3 or c3 helps control the center and protects your king.',
        narration: 'Develop your knights early.',
      },
      {
        kind: 'demo',
        title: 'Watch a knight develop',
        body: 'White develops the knight to f3. It controls the center and eyes e5 and d4.',
        fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
        highlight: { from: 'g1', to: 'f3' },
      },
      {
        kind: 'quiz',
        title: 'Opening check',
        body: 'A quick check on your opening.',
        questions: [
          { prompt: 'Which piece should come out early?', choices: ['The knight', 'The king', 'The same pawn over and over'], correct: 0 },
          { prompt: 'Why fight for the center?', choices: ['Center pieces control many squares', 'The center is closer to the corner'], correct: 0 },
        ],
      },
    ],
  },
  {
    id: 'fight-for-center',
    slug: 'opening-fight-for-center',
    title: 'Fight for the center',
    audienceLevel: 'beginner',
    concepts: ['opening', 'board-control'],
    steps: [
      {
        kind: 'explain',
        title: 'The center is the prize',
        body: 'From the center, your pieces reach every part of the board. Pawns in the center — d4 and e4 — fight for those key squares.',
        narration: 'Push your pawns to the center.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Claim the center',
        body: 'Push a pawn into the center. Which pawn move starts the fight?',
        fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
        answer: ['e4', 'd4'],
        hint: 'Push the d-pawn or the e-pawn two squares.',
      },
      {
        kind: 'quiz',
        title: 'Center check',
        body: 'A quick check on the center.',
        questions: [
          { prompt: 'Which two pawns fight for the center?', choices: ['The a- and h-pawns', 'The d- and e-pawns', 'The b- and g-pawns'], correct: 1 },
          { prompt: 'A pawn can move two squares from its starting square.', choices: ['True', 'False'], correct: 0 },
        ],
      },
    ],
  },
];
